module.exports = __webpack_public_path__ + "static/media/ARBOL_DE_VIDA.7c86c403.jpg";